var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 10H19.75C20.4404 10 21 10.5596 21 11.25V20.125C21 21.1605 20.1605 22 19.125 22H18.875C17.8395 22 17 21.1605 17 20.125V10Z",
    stroke: "#9C2D56",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7577 21.9964L18.9353 22.7251L18.8039 21.2478L18.7577 21.9964ZM3.75 4.5C3.75 3.5335 4.5335 2.75 5.5 2.75V1.25C3.70507 1.25 2.25 2.70507 2.25 4.5H3.75ZM3.75 19.5V4.5H2.25V19.5H3.75ZM5.5 21.25C4.5335 21.25 3.75 20.4665 3.75 19.5H2.25C2.25 21.2949 3.70507 22.75 5.5 22.75V21.25ZM18.7271 21.25H5.5V22.75H18.7271V21.25ZM18.5802 21.2677C18.6294 21.2557 18.6788 21.25 18.7271 21.25V22.75C18.7969 22.75 18.8668 22.7418 18.9353 22.7251L18.5802 21.2677ZM18.8039 21.2478C18.2161 21.2115 17.75 20.7224 17.75 20.125H16.25C16.25 21.5199 17.3376 22.6602 18.7115 22.745L18.8039 21.2478ZM17.75 20.125V19.6809H16.25V20.125H17.75ZM17.75 19.6809V10H16.25V19.6809H17.75ZM16.25 4.5V10H17.75V4.5H16.25ZM14.5 2.75C15.4665 2.75 16.25 3.5335 16.25 4.5H17.75C17.75 2.70507 16.2949 1.25 14.5 1.25V2.75ZM5.5 2.75H14.5V1.25H5.5V2.75Z",
    fill: "#9C2D56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 9H14",
    stroke: "#9C2D56",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12H14",
    stroke: "#9C2D56",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6 15H14",
    stroke: "#9C2D56",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/Document.62665209d85f5ee4660fe45a65f31ab8.svg";
export { ForwardRef as ReactComponent };